// src/components/SidebarItem.js
import React from "react";
import { NavLink } from "react-router-dom";
import styles from "./SidebarItem.module.css";

export default function SidebarItem({ label, icon: Icon, path, collapsed, end = false }) {
  // Check if icon is a string (PNG/image URL) or a React component (SVG)
  const isImageUrl = typeof Icon === 'string';

  return (
    <NavLink
      to={`/dashboard/${path}`}
      end={end}
      className={({ isActive }) =>
        `${styles.item} ${isActive ? styles.active : ""}`
      }
    >
      {isImageUrl ? (
        <img src={Icon} alt={label} className={styles.icon} />
      ) : (
        <Icon className={styles.icon} />
      )}
      {!collapsed && <span className={styles.label}>{label}</span>}
    </NavLink>
  );
}
